<template>
  <b-row class="mt-2">
    <b-col cols="12" class="mt-4">
      <div class="titlePage mb-3">Upload das Provas</div>
    </b-col>
    <b-col cols="7" class="mb-2">
      <b-form-file v-model="fileForm" multiple placeholder="Arquivos..." accept=".pdf" />
    </b-col>
    <b-col cols="4" class="mb-2">
      <fcc-button @click="enviarArquivos" :disabled="!fileForm || fileForm.length == 0">
        Upload
      </fcc-button>
    </b-col>
    <b-col cols="12" class="mt-3">
      <fcc-table
        striped
        hover
        :fields="fieldsUploadProvas"
        :items="lstUploadProvas"
        responsive
        :mostrarQuantidade="false"
        :actions="actionsUpload"
        :por-page="'100'"
        pagination
      >
        <template #npendentes="{ value }">
          <fcc-button
            :disabled="lstProvasPendentes.length == 0"
            @click="abrirProvasPendentes"
            color="outline-primary"
            size="sm"
          >
            {{ value }}
          </fcc-button>
        </template>
      </fcc-table>
    </b-col>
    <fcc-modal
      centered
      id-modal="provasPendentes"
      title-modal="Provas Pendentes"
      esconde-footer
      trava-esc
      size="lg"
      trava-back
    >
      <b-list-group v-if="lstProvasPendentes.length > 0">
        <b-list-group-item v-for="(item, index) in lstProvasPendentes" :key="index">
          {{ item }}
        </b-list-group-item>
      </b-list-group>
    </fcc-modal>
  </b-row>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      fieldsUploadProvas: [
        { key: 'tecnico', label: 'Técnico' },
        {
          key: 'nprovas',
          label: 'Total de Provas',
          tdClass: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'npendentes',
          label: 'Nº Provas Pendentes',
          type: 'slot',
          tdClass: 'text-center',
          thClass: 'text-center'
        },
        { key: 'tecnico', label: 'Data do Upload' },
        { key: 'actions', label: '', thClass: 'no-print' }
      ],
      actionsUpload: [],
      fileForm: null,
      lstUploadProvas: [],
      lstProvasPendentes: []
    }
  },
  watch: {
    liberarExportacao() {
      this.verificaBloqueio(this.liberarExportacao)
    }
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.listarControleUploadProva()
    this.listarProvasPendentes()
    this.verificaBloqueio(this.liberarExportacao)
  },
  props: {
    idNotificacao: String,
    liberarExportacao: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    verificaBloqueio(ativa) {
      if (ativa) {
        this.actionsUpload = [
          {
            button: true,
            funcaoButton: 'bloqueadoStatusLiberacao',
            icon: 'lock',
            tooltip: 'Bloqueado',
            objpermCodigo: store.state.permissaoMenu.editar
          }
        ]
      } else {
        this.actionsUpload = [
          {
            button: true,
            funcaoButton: this.deletaUploadProvas,
            icon: 'trash-alt',
            tooltip: 'Deletar',
            objpermCodigo: store.state.permissaoMenu.executar
          }
        ]
      }
    },
    abrirProvasPendentes() {
      this.listarProvasPendentes()
      this.$root.$emit('bv::show::modal', 'provasPendentes')
    },
    listarProvasPendentes() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao +
            `PublicacaoGabarito/ListarArquivosPendentes/${this.idNotificacao}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstProvasPendentes = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listarControleUploadProva() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao +
            `PublicacaoGabarito/GetControleUploadProva/${this.idNotificacao}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstUploadProvas = response.data ? [response.data] : []
          this.$emit('provasPendentes', response.data.npendentes)
          this.$emit('totalProvas', response.data.nprovas)
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    deletaUploadProvas() {
      this.callConfirm(`Tem certeza que deseja deletar?`, '').then(() => {
        this.carregaTexto(this.codeMensagem('C02'))
        axios
          .delete(
            this.baseUrlPublicacao + `PublicacaoGabarito/DeletarUpload/${this.idNotificacao}`,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listarProvasPendentes()
            this.listarControleUploadProva()
            this.carregaTexto()
            this.callToast(this.mensagensUpdate.excluido)
          })
          .catch(this.setErrorSystem)
      })
    },
    enviarArquivos() {
      this.callConfirm(`Tem certeza que deseja enviar arquivos?`, '').then(() => {
        this.carregaTexto('Enviando arquivos')
        const arquivo = new FormData()
        this.fileForm.forEach((element) => {
          arquivo.append('listaArquivos', element)
        })
        axios
          .post(
            this.baseUrlPublicacao +
              `PublicacaoGabarito/EnviarArquivo?idPublicacao=${this.idNotificacao}`,
            arquivo,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.fileForm = null
            this.callToast('Sucesso', 'success', 'success')
            this.carregaTexto()
            this.listarControleUploadProva()
          })
          .catch(this.setErrorSystem)
      })
    }
  }
}
</script>
